'use client'
import styled from 'styled-components'

const StyledVideo = styled.video`
  height: 150px;
  width: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const LoaderVideo = ({ src }: { src: string }) => {
  return (
    <StyledVideo autoPlay loop muted playsInline>
      <source src={src} type="video/mp4" />
    </StyledVideo>
  )
}

export default LoaderVideo
